import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { ThemeProvider } from "./context/ThemeContext.jsx";
import "./App.css";
import "./helper.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/nco-ui.css";

import * as Sentry from "@sentry/react";

if (process.env.NODE_ENV === "production") {
    Sentry.init({
        dsn: "https://1f94c153d51b13c34c6074f241a4b839@o4509599485067264.ingest.us.sentry.io/4509599485984768",
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
            Sentry.browserProfilingIntegration(),
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: ["http://api.netcyberops.com/", "https://api.netcyberops.com/"],
        // replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        // Add beforeSend callback to filter out specific routes
        beforeSend: (event, hint) => {
            // Check if this is a large payload event for the files endpoint
            if (event.exception &&
                event.exception.values &&
                event.exception.values.some(ex =>
                    ex.value && ex.value.includes("Large HTTP payload") &&
                    ex.value.includes("/v1/files/")
                )) {
                return null; // Drop the event completely
            }
            return event; // Send all other events
        },
        environment: import.meta.env.MODE
    });
}

ReactDOM.createRoot(document.getElementById("root")).render(
    // <React.StrictMode>
    <ThemeProvider>
        <App/>
    </ThemeProvider>
    // </React.StrictMode>
);
